import { z } from 'zod';

import { preferredLanguageSchema } from './language';
import { projectUserRoleSchema } from './projectUser';

export type Invite = z.infer<typeof inviteSchema>;
const inviteDateSchema = z.string().refine((value) => {
  const normalized = value.includes(' ') ? value.replace(' ', 'T') : value;
  return !Number.isNaN(Date.parse(normalized));
}, 'Invalid datetime');

export const inviteAssignmentSchema = z.object({
  projectId: z.number(),
  role: projectUserRoleSchema,
  expiryDate: z.string().nullable().optional(),
});

export const inviteSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  keycloakInviteId: z.string(),
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  phoneNr: z.string().nullable().optional(),
  companyId: z.number().nullable().optional(),
  personalConsumer: z.boolean().optional(),
  companyName: z.string().nullable().optional(),
  status: z.enum(['PENDING', 'REGISTERED', 'COMPLETED', 'CANCELLED']),
  keycloakStatus: z.string().nullable().optional(),
  createdAt: inviteDateSchema,
  completedAt: inviteDateSchema.nullable().optional(),
  role: projectUserRoleSchema.nullable().optional(),
  expiryDate: z.string().nullable().optional(),
  projectAssignments: z.array(z.number()).optional(),
  assignments: z.array(inviteAssignmentSchema).optional(),
  inviteLink: z.string().url().nullable().optional(),
});
export const inviteResponseSchema = z.object({
  invites: z.array(inviteSchema),
});

export type SendInviteBody = z.infer<typeof sendInviteBodySchema>;
export const sendInviteBodySchema = z.object({
  email: z.string().email(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phoneNr: z.string().optional(),
  companyId: z.number().optional(),
  personalConsumer: z.boolean().optional(),
  companyName: z.string().optional(),
  preferredLanguage: preferredLanguageSchema,
  role: projectUserRoleSchema.optional(),
  projectAssignments: z.array(z.number()).optional(),
});
export const createInviteResponseSchema = z.object({
  id: z.number(),
  email: z.string().email(),
  keycloakInviteId: z.string(),
  status: z.enum(['PENDING', 'REGISTERED', 'COMPLETED', 'CANCELLED']),
  createdAt: inviteDateSchema,
});
